import { render, staticRenderFns } from "./InsMenu.vue?vue&type=template&id=3e230501&scoped=true"
import script from "./InsMenu.vue?vue&type=script&lang=ts"
export * from "./InsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e230501",
  null
  
)

export default component.exports